module.exports = __webpack_public_path__ + "media/images/common/h3_hall_of_fame-49ad0ec382c9d0e2c62b66b35da4a73b.png";